import { Group, TooltipProps, Text, TextProps } from "@mantine/core"
import { ReactElement, ReactNode } from "react"

import { Label } from "../../atoms/Label/Label"
import { HelpHover } from "../HelpHover/HelpHover"

type LabelWithTooltipProps = {
  label: ReactNode
  labelClassName?: string
  disabledTooltip?: boolean
  hoverHelperText?: string
  hoverHelperIcon?: ReactElement<SVGElement>
  justify?: "start" | "end" | "space-between" | "space-around" | "center"
  toolTipProps?: TooltipProps
  withAsterisk?: boolean
} & TextProps

export function LabelWithTooltip({
  label,
  hoverHelperText,
  justify = "space-between",
  size = "xs",
  disabledTooltip = false, // add this to show tooltip even when text isn't overflowing
  withAsterisk = false,
  fw,
  w = "100%",
  ...props
}: LabelWithTooltipProps) {
  return (
    <Group w="100%" justify={justify} wrap="nowrap">
      <Label
        label={label}
        size={size}
        withAsterisk={withAsterisk}
        disabledTooltip={disabledTooltip}
        fw={fw}
        w={w}
        {...props}
      />
      {hoverHelperText && (
        <HelpHover>
          <Text maw="100%" size="xs" w="fit-content">
            {hoverHelperText}
          </Text>
        </HelpHover>
      )}
    </Group>
  )
}
